module.exports = __webpack_public_path__ + "media/images/icon-conscious-b4876b952e9d491d36898c7e3eeb9cf8.svg";